/**
 * ARKS Store - Core Theme JavaScript
 */

// Global Profile Modal Controller
window.ARKS_ProfileModal = {
  modalEl: null,
  
  init() {
    this.modalEl = document.getElementById('GlobalProfileModal');
    if (!this.modalEl) return;

    // Close on backdrop click
    this.modalEl.addEventListener('click', (e) => {
      if (e.target === this.modalEl) {
        this.close();
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modalEl.classList.contains('is-active')) {
        this.close();
      }
    });
  },

  open(tabName = 'profile-details') {
    if (!this.modalEl) this.modalEl = document.getElementById('GlobalProfileModal');
    if (!this.modalEl) return;

    this.modalEl.style.display = 'flex';
    // Small timeout for smooth CSS transition
    setTimeout(() => {
      this.modalEl.classList.add('is-active');
    }, 10);
    document.body.style.overflow = 'hidden';

    // Close header dropdown if open
    const dropdown = document.querySelector('#HeaderProfileDropdown');
    const toggle = document.querySelector('#HeaderProfileToggle');
    if (dropdown) dropdown.classList.remove('is-active');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    this.switchTab(tabName);
    loadProfileBag();
    loadProfileWishlist();
  },

  close() {
    if (!this.modalEl) this.modalEl = document.getElementById('GlobalProfileModal');
    if (!this.modalEl) return;

    this.modalEl.classList.remove('is-active');
    setTimeout(() => {
      this.modalEl.style.display = 'none';
      document.body.style.overflow = '';
    }, 250);
  },

  switchTab(tabName, shouldScroll = false) {
    if (!tabName) return;

    // Switch tabs across ALL profile dashboard containers (standalone page, 404 router, and modal)
    const allDashboards = document.querySelectorAll('.profile-dashboard-grid');
    allDashboards.forEach(dashboard => {
      const navItems = dashboard.querySelectorAll('.profile-nav-item[data-tab-target]');
      const panes = dashboard.querySelectorAll('.profile-tab-pane[data-tab-pane]');

      navItems.forEach(item => {
        if (item.getAttribute('data-tab-target') === tabName) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });

      panes.forEach(pane => {
        if (pane.getAttribute('data-tab-pane') === tabName) {
          pane.style.display = 'block';
          pane.classList.add('is-active');
        } else {
          pane.style.display = 'none';
          pane.classList.remove('is-active');
        }
      });

      // Auto scroll active nav pill horizontally into view on mobile
      const activeNavPill = dashboard.querySelector('.profile-nav-item.is-active');
      if (activeNavPill && typeof activeNavPill.scrollIntoView === 'function') {
        try {
          activeNavPill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch (e) {}
      }
    });

    // Always close Header Profile Dropdown when any profile tab/page is activated
    const dd = document.getElementById('HeaderProfileDropdown');
    const tg = document.getElementById('HeaderProfileToggle');
    if (dd) dd.classList.remove('is-active');
    if (tg) tg.setAttribute('aria-expanded', 'false');

    if (tabName === 'bag') loadProfileBag();
    if (tabName === 'wishlist') loadProfileWishlist();

    if (shouldScroll) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};

// Global Helpers
window.ARKS_QuickCart = {
  add(handle, title, price, image) {
    let demoCart = [];
    try {
      demoCart = JSON.parse(localStorage.getItem('arks_demo_cart') || '[]');
    } catch(e) {}

    const existing = demoCart.find(item => item.handle === handle);
    if (existing) {
      existing.quantity += 1;
    } else {
      demoCart.push({
        handle: handle,
        product_title: title,
        title: title,
        final_price: parseFloat(price) * 100,
        final_line_price: parseFloat(price) * 100,
        quantity: 1,
        featured_image: { url: image },
        url: '/products/' + handle
      });
    }

    localStorage.setItem('arks_demo_cart', JSON.stringify(demoCart));
    showArksToast(title + ' added to your Bag!');

    // Update bag count badges
    const totalCount = demoCart.reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('.profile-bag-badge, .cart-count-badge').forEach(badge => {
      badge.textContent = totalCount;
      badge.style.display = '';
    });
  }
};

window.openOrderTracker = function(orderNum, courier, status) {
  const modal = document.getElementById('ArksOrderTrackerModal');
  if (!modal) return;
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  const numEl = modal.querySelector('#TrackerOrderNumber') || document.getElementById('TrackerOrderNumber');
  const courierEl = modal.querySelector('#TrackerCourierName') || document.getElementById('TrackerCourierName');
  const statusEl = modal.querySelector('#TrackerStatusText') || document.getElementById('TrackerStatusText');

  if (numEl) numEl.textContent = 'Order #' + orderNum;
  if (courierEl) courierEl.textContent = 'Courier: ' + courier;
  if (statusEl) statusEl.textContent = status;

  modal.style.display = 'flex';
};

window.closeOrderTracker = function() {
  document.querySelectorAll('#ArksOrderTrackerModal').forEach(modal => {
    modal.style.display = 'none';
  });
};

window.copyCouponCode = function(code, btn) {
  if (!code) return;

  function showCopiedSuccess() {
    if (btn) {
      const original = btn.dataset.origText || btn.innerText;
      btn.dataset.origText = original;
      btn.innerText = '✓ COPIED!';
      btn.style.backgroundColor = '#10B981';
      btn.style.color = '#FFFFFF';
      btn.style.borderColor = '#10B981';
      setTimeout(() => {
        btn.innerText = original;
        btn.style.backgroundColor = '';
        btn.style.color = '';
        btn.style.borderColor = '';
      }, 2000);
    }
    showArksToast('Coupon code ' + code + ' copied to clipboard!');
  }

  function fallbackCopy(text) {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopiedSuccess();
    } catch (e) {
      showCopiedSuccess();
    }
  }

  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    navigator.clipboard.writeText(code).then(showCopiedSuccess).catch(() => fallbackCopy(code));
  } else {
    fallbackCopy(code);
  }
};

window.showArksToast = function(message) {
  const existing = document.querySelector('.arks-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'arks-toast';
  toast.innerHTML = '<span>✓</span> <span>' + message + '</span>';
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
};

window.arksProfileLogout = function() {
  showArksToast('Signing out...');
  setTimeout(() => {
    if (window.ARKS_ProfileModal) window.ARKS_ProfileModal.close();
    window.location.href = '/';
  }, 800);
};

window.updateProfileBagQty = function(line, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: Math.max(0, newQty) })
  })
    .then(res => res.json())
    .then(() => {
      loadProfileBag();
      if (window.ARKS_Cart && typeof window.ARKS_Cart.getCart === 'function') {
        window.ARKS_Cart.getCart();
      }
      showArksToast(newQty <= 0 ? 'Item removed from bag' : 'Bag quantity updated');
    })
    .catch(() => {});
};

// Bag / Cart Loader
function loadProfileBag() {
  const bagContainers = document.querySelectorAll('.profile-bag-container');
  if (!bagContainers.length) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Update badge counts
      document.querySelectorAll('.profile-bag-badge, .cart-count-badge').forEach(badge => {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0 || badge.classList.contains('profile-bag-badge')) {
          badge.style.display = '';
        }
      });

      bagContainers.forEach(container => {
        const loading = container.querySelector('.profile-bag-loading');
        const list = container.querySelector('.profile-bag-items-list');
        const summary = container.querySelector('.profile-bag-summary');
        const empty = container.querySelector('.profile-bag-empty');
        const subtotal = container.querySelector('.profile-bag-subtotal');

        if (loading) loading.style.display = 'none';

        if (!cart.items || cart.item_count === 0) {
          if (list) list.style.display = 'none';
          if (summary) summary.style.display = 'none';
          if (empty) empty.style.display = 'block';
        } else {
          if (empty) empty.style.display = 'none';
          if (list) {
            list.style.display = 'flex';
            list.innerHTML = cart.items.map((item, idx) => {
              const line = idx + 1;
              const imgUrl = (item.featured_image && item.featured_image.url)
                ? item.featured_image.url
                : (item.image || item.featured_image || 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&w=300&q=80');
              const unitPrice = ((item.final_price ?? item.price ?? 0) / 100).toFixed(2);
              const linePrice = ((item.final_line_price ?? item.line_price ?? 0) / 100).toFixed(2);
              return `
                <div style="display: flex; gap: 14px; align-items: center; border: 1px solid #f0f0f2; border-radius: 12px; padding: 14px; background: #fff; flex-wrap: wrap;">
                  <img src="${imgUrl}" alt="${item.title || item.product_title}" style="width: 64px; height: 64px; object-fit: cover; border-radius: 8px; border: 1px solid #f0f0f2;">
                  <div style="flex: 1; min-width: 140px;">
                    <a href="${item.url || '#'}" style="font-weight: 700; color: #282c3f; text-decoration: none; font-size: 14px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${item.product_title || item.title}</a>
                    <div style="font-size: 12.5px; color: #7e818c; margin-top: 2px;">${item.variant_title || ''}</div>
                    <div style="font-size: 14px; font-weight: 700; color: var(--color-primary); margin-top: 4px;">₹${unitPrice}</div>
                  </div>
                  <div style="text-align: right; flex-shrink: 0; display: flex; flex-direction: column; align-items: flex-end; gap: 6px;">
                    <div style="display: inline-flex; align-items: center; border: 1px solid #eaeaec; border-radius: 6px; overflow: hidden;">
                      <button type="button" onclick="updateProfileBagQty(${line}, ${item.quantity - 1})" style="border: none; background: #f8f9fa; padding: 4px 10px; cursor: pointer; font-weight: 700;">-</button>
                      <span style="padding: 2px 10px; font-size: 13px; font-weight: 700;">${item.quantity}</span>
                      <button type="button" onclick="updateProfileBagQty(${line}, ${item.quantity + 1})" style="border: none; background: #f8f9fa; padding: 4px 10px; cursor: pointer; font-weight: 700;">+</button>
                    </div>
                    <div style="font-size: 14.5px; font-weight: 800; color: #282c3f;">₹${linePrice}</div>
                    <button type="button" onclick="updateProfileBagQty(${line}, 0)" style="border: none; background: none; color: #DC2626; font-size: 11.5px; font-weight: 600; cursor: pointer; padding: 0;">Remove</button>
                  </div>
                </div>
              `;
            }).join('');
          }
          if (summary) {
            summary.style.display = 'block';
            if (subtotal) subtotal.textContent = `₹${((cart.total_price || 0) / 100).toFixed(2)}`;
          }
        }
      });
    })
    .catch(() => {});
}

window.removeProfileWishlistItem = function(handle) {
  if (window.ARKS_Wishlist && typeof window.ARKS_Wishlist.removeItem === 'function') {
    window.ARKS_Wishlist.removeItem(handle);
  } else {
    try {
      const cur = JSON.parse(localStorage.getItem('arks_store_wishlist_items') || localStorage.getItem('arks_wishlist') || '[]');
      const filtered = cur.filter(i => i.handle !== handle);
      localStorage.setItem('arks_store_wishlist_items', JSON.stringify(filtered));
      localStorage.setItem('arks_wishlist', JSON.stringify(filtered));
    } catch (e) {}
  }
  loadProfileWishlist();
};

// Wishlist Loader
function loadProfileWishlist() {
  let items = [];
  try {
    items = JSON.parse(localStorage.getItem('arks_store_wishlist_items') || localStorage.getItem('arks_wishlist') || '[]');
  } catch(e) {}

  document.querySelectorAll('.profile-wishlist-badge, .wishlist-pill-count, .wishlist-count-badge').forEach(badge => {
    badge.textContent = items.length;
    if (items.length > 0 || badge.classList.contains('profile-wishlist-badge') || badge.classList.contains('wishlist-pill-count')) {
      badge.style.display = '';
    }
  });

  const containers = document.querySelectorAll('.profile-wishlist-container');
  containers.forEach(container => {
    const empty = container.querySelector('.profile-wishlist-empty');
    const grid = container.querySelector('.profile-wishlist-grid');

    if (items.length === 0) {
      if (empty) empty.style.display = 'block';
      if (grid) grid.style.display = 'none';
    } else {
      if (empty) empty.style.display = 'none';
      if (grid) {
        grid.style.display = 'grid';
        grid.innerHTML = items.map(p => `
          <div style="border: 1px solid #eaeaec; border-radius: 12px; padding: 14px; background: #fff; text-align: center; box-shadow: 0 2px 6px rgba(0,0,0,0.02); position: relative;">
            <button type="button" onclick="removeProfileWishlistItem('${p.handle || ''}')" title="Remove" style="position: absolute; top: 18px; right: 18px; width: 28px; height: 28px; border-radius: 50%; border: none; background: rgba(255,255,255,0.9); color: #DC2626; font-weight: 700; cursor: pointer; box-shadow: 0 2px 6px rgba(0,0,0,0.12);">&times;</button>
            <img src="${p.image || ''}" alt="${p.title || ''}" style="width: 100%; height: 150px; object-fit: cover; border-radius: 8px; margin-bottom: 10px;">
            <strong style="font-size: 13.5px; color: #282c3f; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 4px;">${p.title || ''}</strong>
            <div style="font-size: 14.5px; font-weight: 700; color: var(--color-primary); margin-bottom: 10px;">${p.price || ''}</div>
            <a href="${p.url || '#'}" class="btn btn-primary btn-sm" style="width: 100%; font-size: 11.5px; padding: 7px;">VIEW ITEM</a>
          </div>
        `).join('');
      }
    }
  });
}

// Main DOM Ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Profile Modal
  window.ARKS_ProfileModal.init();

  // Sticky Header Effect
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    }, { passive: true });
  }

  // Mobile Navigation Drawer Toggle ("3 Dots" / Menu Toggle)
  const mobileNavToggles = document.querySelectorAll('.mobile-nav-toggle, #MobileNavToggle');
  const mobileNavDrawer = document.querySelector('#MobileNavDrawer');
  const mobileNavClose = document.querySelector('.mobile-nav-close');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');

  function openMobileNav() {
    if (mobileNavDrawer) {
      mobileNavDrawer.classList.add('is-open');
      if (mobileOverlay) mobileOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      mobileNavToggles.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    }
  }

  function closeMobileNav() {
    if (mobileNavDrawer) {
      mobileNavDrawer.classList.remove('is-open');
      if (mobileOverlay) mobileOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      mobileNavToggles.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  }

  function toggleMobileNav(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (mobileNavDrawer && mobileNavDrawer.classList.contains('is-open')) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  mobileNavToggles.forEach(btn => {
    btn.addEventListener('click', toggleMobileNav);
  });

  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('.mobile-nav-toggle, #MobileNavToggle');
    if (toggleBtn) {
      toggleMobileNav(e);
    }
  });

  if (mobileNavClose) {
    mobileNavClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileNav();
    });
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileNav();
    });
  }

  // Close Mobile Drawer on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNavDrawer && mobileNavDrawer.classList.contains('is-open')) {
      closeMobileNav();
    }
  });

  // Close Mobile Drawer on clicking any internal navigation link
  if (mobileNavDrawer) {
    mobileNavDrawer.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        closeMobileNav();
      });
    });
  }

  // Accordion Component (Metafields, FAQs, Support FAQs)
  document.addEventListener('click', (e) => {
    const accHeader = e.target.closest('.accordion-header');
    if (!accHeader) return;

    const item = accHeader.closest('.accordion-item');
    if (!item) return;

    const parentAccordion = item.closest('.pdp-accordion');
    const isSingle = parentAccordion && parentAccordion.dataset.single === 'true';

    const isOpen = item.classList.contains('is-open');

    if (isSingle) {
      parentAccordion.querySelectorAll('.accordion-item').forEach(other => {
        if (other !== item) {
          other.classList.remove('is-open');
          const otherContent = other.querySelector('.accordion-content');
          if (otherContent) otherContent.style.display = 'none';
        }
      });
    }

    if (!isOpen) {
      item.classList.add('is-open');
      const content = item.querySelector('.accordion-content');
      if (content) content.style.display = 'block';
    } else {
      item.classList.remove('is-open');
      const content = item.querySelector('.accordion-content');
      if (content) content.style.display = 'none';
    }
  });

  // Profile Dropdown Toggle & Sync
  const profileToggle = document.querySelector('#HeaderProfileToggle');
  const profileDropdown = document.querySelector('#HeaderProfileDropdown');
  const profileWrapper = document.querySelector('#HeaderProfileWrapper');

  // Sync avatar and profile data across the site
  function syncAllProfileData() {
    const savedPhoto = localStorage.getItem('arks_profile_photo');
    const defaultPhoto = 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80';
    const photoToSet = savedPhoto || defaultPhoto;

    document.querySelectorAll('.profile-avatar-img-dynamic, #HeaderAvatarImg, #DropdownAvatarImg, #AvatarActionPreviewImg').forEach(img => {
      img.src = photoToSet;
    });

    const savedProfileData = localStorage.getItem('arks_user_profile_data');
    if (savedProfileData) {
      try {
        const data = JSON.parse(savedProfileData);
        if (data.name) {
          document.querySelectorAll('.profile-name-dynamic, #DropdownUserName').forEach(el => el.textContent = data.name);
          document.querySelectorAll('.input-edit-name').forEach(el => el.value = data.name);
          document.querySelectorAll('.addr1-name').forEach(el => el.textContent = data.name + ' (Home)');
        }
        if (data.phone) {
          document.querySelectorAll('.profile-phone-dynamic, .addr1-phone').forEach(el => el.textContent = data.phone);
          document.querySelectorAll('.input-edit-phone').forEach(el => el.value = data.phone);
        }
        if (data.email) {
          document.querySelectorAll('.profile-email-dynamic, #DropdownUserEmail').forEach(el => el.textContent = data.email);
          document.querySelectorAll('.input-edit-email').forEach(el => el.value = data.email);
        }
        if (data.gender) {
          document.querySelectorAll('.profile-gender-dynamic').forEach(el => el.textContent = data.gender);
          document.querySelectorAll('.input-edit-gender').forEach(el => el.value = data.gender);
        }
        if (data.dob) {
          document.querySelectorAll('.profile-dob-dynamic').forEach(el => el.textContent = data.dob);
          document.querySelectorAll('.input-edit-dob').forEach(el => el.value = data.dob);
        }
        if (data.loc) {
          document.querySelectorAll('.profile-loc-dynamic').forEach(el => el.textContent = data.loc);
          document.querySelectorAll('.input-edit-loc').forEach(el => el.value = data.loc);
        }
        if (data.alt) {
          document.querySelectorAll('.profile-alt-dynamic').forEach(el => el.textContent = data.alt);
          document.querySelectorAll('.input-edit-alt').forEach(el => el.value = data.alt);
        }
      } catch(e) {}
    }

    syncCustomerTiers();
  }

  // Dynamic Membership & Tier Progression Engine
  function syncCustomerTiers() {
    const container = document.querySelector('.profile-dashboard-grid');
    if (!container) return;

    const bronzeName = container.dataset.tierBronze || 'Bronze Member';
    const silverName = container.dataset.tierSilver || 'Silver Member';
    const silverSpend = parseFloat(container.dataset.tierSilverSpend) || 5000;
    const goldName = container.dataset.tierGold || 'Gold Member';
    const goldSpend = parseFloat(container.dataset.tierGoldSpend) || 15000;
    const diamondName = container.dataset.tierDiamond || 'Diamond Member';
    const diamondSpend = parseFloat(container.dataset.tierDiamondSpend) || 30000;
    const diamondCode = container.dataset.tierDiamondCode || 'DIAMOND25';
    const platinumName = container.dataset.tierPlatinum || 'Platinum VIP Member';
    const platinumSpend = parseFloat(container.dataset.tierPlatinumSpend) || 50000;
    const platinumCode = container.dataset.tierPlatinumCode || 'PLATINUM30';

    let userSpend = parseFloat(localStorage.getItem('arks_customer_spend'));
    if (isNaN(userSpend)) {
      userSpend = parseFloat(container.dataset.customerSpent) || 5800;
    }

    let currentTier = 'bronze';
    let currentBadge = bronzeName;
    let currentIcon = '🥉';
    let nextTierName = silverName;
    let nextTierSpend = silverSpend;
    let prevTierSpend = 0;
    let cashbackRate = '2% Basic Cashback';

    if (userSpend >= platinumSpend) {
      currentTier = 'platinum';
      currentBadge = platinumName;
      currentIcon = '👑';
      nextTierName = 'MAX TIER';
      nextTierSpend = platinumSpend;
      prevTierSpend = diamondSpend;
      cashbackRate = '15% Elite Cashback + Free Delivery';
    } else if (userSpend >= diamondSpend) {
      currentTier = 'diamond';
      currentBadge = diamondName;
      currentIcon = '💎';
      nextTierName = platinumName;
      nextTierSpend = platinumSpend;
      prevTierSpend = goldSpend;
      cashbackRate = '12% Diamond Cashback + 25% OFF';
    } else if (userSpend >= goldSpend) {
      currentTier = 'gold';
      currentBadge = goldName;
      currentIcon = '🥇';
      nextTierName = diamondName;
      nextTierSpend = diamondSpend;
      prevTierSpend = silverSpend;
      cashbackRate = '10% Gold Cashback';
    } else if (userSpend >= silverSpend) {
      currentTier = 'silver';
      currentBadge = silverName;
      currentIcon = '🥈';
      nextTierName = goldName;
      nextTierSpend = goldSpend;
      prevTierSpend = 0;
      cashbackRate = '5% Silver Cashback';
    }

    // Update Badges Across Site
    document.querySelectorAll('.profile-tier-dynamic').forEach(el => {
      el.className = `profile-tier-badge profile-tier-dynamic tier-${currentTier}`;
      el.innerHTML = `${currentIcon} ${currentBadge}`;
    });

    // Update Spend Text
    const totalSpendEl = document.getElementById('TierTotalSpendAmount');
    if (totalSpendEl) totalSpendEl.textContent = `₹${userSpend.toLocaleString('en-IN')}.00`;

    const cashbackTextEl = document.getElementById('TierCashbackRateText');
    if (cashbackTextEl) cashbackTextEl.textContent = cashbackRate;

    // Calculate Progress Percent to Next Tier
    let progressPercent = 100;
    if (currentTier !== 'platinum') {
      const range = nextTierSpend - prevTierSpend;
      const currentProgress = userSpend - prevTierSpend;
      progressPercent = Math.min(100, Math.max(8, Math.round((currentProgress / range) * 100)));
    }

    const fillBar = document.getElementById('TierProgressFillBar');
    if (fillBar) fillBar.style.width = `${progressPercent}%`;

    const percentText = document.getElementById('TierProgressPercentText');
    if (percentText) {
      percentText.textContent = currentTier === 'platinum' ? '👑 Highest VIP Tier' : `${progressPercent}% to ${nextTierName}`;
    }

    const nextGoalEl = document.getElementById('TierNextGoalText');
    if (nextGoalEl) {
      if (currentTier === 'platinum') {
        nextGoalEl.innerHTML = `🎉 <strong>Congratulations!</strong> You have achieved the highest <strong>👑 ${platinumName}</strong> tier with <strong>30% OFF (${platinumCode}) + Free Express Delivery</strong> on every purchase!`;
      } else {
        const remaining = nextTierSpend - userSpend;
        let perkDesc = `upgrade your benefits!`;
        if (nextTierName === diamondName) perkDesc = `unlock <strong>Flat 25% OFF (${diamondCode})</strong> on every purchase!`;
        else if (nextTierName === platinumName) perkDesc = `unlock <strong>Flat 30% OFF (${platinumCode}) + Free Express Delivery</strong>!`;
        else if (nextTierName === goldName) perkDesc = `unlock <strong>10% Extra Cashback & Priority Dispatch</strong>!`;
        
        nextGoalEl.innerHTML = `🛍️ Shop for <strong>₹${remaining.toLocaleString('en-IN')} more</strong> to unlock <strong>${nextTierName}</strong> and ${perkDesc}`;
      }
    }

    // Update Roadmap Nodes
    const tierOrder = ['bronze', 'silver', 'gold', 'diamond', 'platinum'];
    const currentIdx = tierOrder.indexOf(currentTier);
    tierOrder.forEach((t, idx) => {
      document.querySelectorAll(`.node-${t}`).forEach(node => {
        node.classList.toggle('is-achieved', idx <= currentIdx);
        node.classList.toggle('is-current', idx === currentIdx);
      });
    });

    // Update Coupons State
    const btnDiamond = document.getElementById('BtnDiamondCoupon');
    if (btnDiamond) {
      if (userSpend >= diamondSpend) {
        btnDiamond.innerHTML = `✓ COPY DIAMOND CODE (${diamondCode})`;
        btnDiamond.classList.add('btn-primary');
        btnDiamond.classList.remove('btn-outline');
      } else {
        btnDiamond.innerHTML = `🔒 Unlocks at Diamond (Spend ₹${diamondSpend.toLocaleString('en-IN')})`;
      }
    }

    const btnPlatinum = document.getElementById('BtnPlatinumCoupon');
    if (btnPlatinum) {
      if (userSpend >= platinumSpend) {
        btnPlatinum.innerHTML = `✓ COPY PLATINUM VIP CODE (${platinumCode})`;
        btnPlatinum.classList.add('btn-primary');
        btnPlatinum.classList.remove('btn-outline');
      } else {
        btnPlatinum.innerHTML = `🔒 Unlocks at Platinum (Spend ₹${platinumSpend.toLocaleString('en-IN')})`;
      }
    }
  }

  // Global Avatar Action Modal Methods
  window.openAvatarActionModal = function() {
    const modal = document.getElementById('ArksAvatarActionModal');
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    if (profileDropdown) profileDropdown.classList.remove('is-active');
    if (profileToggle) profileToggle.setAttribute('aria-expanded', 'false');
    syncAllProfileData();
    modal.style.display = 'flex';
    setTimeout(() => modal.classList.add('is-active'), 10);
  };

  window.closeAvatarActionModal = function() {
    const modal = document.getElementById('ArksAvatarActionModal');
    if (!modal) return;
    modal.classList.remove('is-active');
    setTimeout(() => { modal.style.display = 'none'; }, 250);
  };

  window.triggerAvatarUpload = function() {
    const fileInput = document.getElementById('GlobalAvatarActionFileInput');
    if (fileInput) {
      fileInput.click();
    }
  };

  window.removeAvatarPhoto = function() {
    localStorage.removeItem('arks_profile_photo');
    syncAllProfileData();
    closeAvatarActionModal();
    if (typeof showArksToast === 'function') {
      showArksToast('Profile photo removed');
    }
  };

  // Avatar Modal Backdrop click & ESC key
  const avatarModalEl = document.getElementById('ArksAvatarActionModal');
  if (avatarModalEl) {
    avatarModalEl.addEventListener('click', (e) => {
      if (e.target === avatarModalEl) {
        window.closeAvatarActionModal();
      }
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && avatarModalEl && avatarModalEl.classList.contains('is-active')) {
      window.closeAvatarActionModal();
    }
  });

  syncAllProfileData();
  loadProfileBag();
  loadProfileWishlist();

  // Header Dropdown Toggle (Strictly Click-Only)
  if (profileToggle && profileDropdown) {
    profileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = profileDropdown.classList.contains('is-active');
      if (isOpen) {
        profileDropdown.classList.remove('is-active');
        profileToggle.setAttribute('aria-expanded', 'false');
      } else {
        profileDropdown.classList.add('is-active');
        profileToggle.setAttribute('aria-expanded', 'true');
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (profileWrapper && !profileWrapper.contains(e.target) && profileDropdown.classList.contains('is-active')) {
        profileDropdown.classList.remove('is-active');
        profileToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && profileDropdown.classList.contains('is-active')) {
        profileDropdown.classList.remove('is-active');
        profileToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Direct Page Navigation for Header Dropdown Items (No modal)
  document.querySelectorAll('[data-profile-tab]').forEach(item => {
    item.addEventListener('click', (e) => {
      if (profileDropdown) profileDropdown.classList.remove('is-active');
      if (profileToggle) profileToggle.setAttribute('aria-expanded', 'false');
      closeMobileNav();

      const tab = item.getAttribute('data-profile-tab') || 'profile-details';
      const isProfilePage = window.location.pathname.includes('/pages/profile') || window.location.pathname.includes('/account');

      if (isProfilePage) {
        e.preventDefault();
        window.location.hash = tab;
        window.ARKS_ProfileModal.switchTab(tab, true);
      }
      // Otherwise, the natural link href="/pages/profile#tab" navigates to the page!
    });
  });

  // Sidebar navigation tab buttons (in standalone page & modal)
  document.addEventListener('click', (e) => {
    const tabBtn = e.target.closest('.profile-nav-item[data-tab-target]');
    if (tabBtn) {
      e.preventDefault();
      const targetTab = tabBtn.getAttribute('data-tab-target');
      if (window.location.pathname.includes('/pages/profile') || window.location.pathname.includes('/account')) {
        history.replaceState(null, '', '#' + targetTab);
      }
      window.ARKS_ProfileModal.switchTab(targetTab, true);
    }
  });

  // Profile Edit Mode Toggles
  document.addEventListener('click', (e) => {
    // Edit Button
    if (e.target.closest('.btn-toggle-edit-profile')) {
      const container = e.target.closest('.profile-tab-pane') || document;
      const viewPanel = container.querySelector('.profile-details-view-panel');
      const editPanel = container.querySelector('.profile-details-edit-panel');
      if (viewPanel && editPanel) {
        viewPanel.style.display = 'none';
        editPanel.style.display = 'block';
      }
    }

    // Cancel Button
    if (e.target.closest('.btn-cancel-edit-profile')) {
      const container = e.target.closest('.profile-tab-pane') || document;
      const viewPanel = container.querySelector('.profile-details-view-panel');
      const editPanel = container.querySelector('.profile-details-edit-panel');
      if (viewPanel && editPanel) {
        editPanel.style.display = 'none';
        viewPanel.style.display = 'block';
      }
    }
  });

  // Profile Edit Form Submit
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.profile-edit-form');
    if (!form) return;
    e.preventDefault();

    const nameInput = form.querySelector('.input-edit-name');
    const phoneInput = form.querySelector('.input-edit-phone');
    const emailInput = form.querySelector('.input-edit-email');
    const genderInput = form.querySelector('.input-edit-gender');
    const dobInput = form.querySelector('.input-edit-dob');
    const locInput = form.querySelector('.input-edit-loc');
    const altInput = form.querySelector('.input-edit-alt');

    const data = {
      name: nameInput ? nameInput.value : 'Priya Sharma',
      phone: phoneInput ? phoneInput.value : '+91 98765 43210',
      email: emailInput ? emailInput.value : 'priya.sharma@example.com',
      gender: genderInput ? genderInput.value : 'Female',
      dob: dobInput ? dobInput.value : '1998-05-14',
      loc: locInput ? locInput.value : 'New Delhi, India',
      alt: altInput ? altInput.value : '+91 98111 22334'
    };

    localStorage.setItem('arks_user_profile_data', JSON.stringify(data));
    syncAllProfileData();

    // Revert form view
    document.querySelectorAll('.profile-details-edit-panel').forEach(p => p.style.display = 'none');
    document.querySelectorAll('.profile-details-view-panel').forEach(p => p.style.display = 'block');

    showArksToast('Profile details updated successfully!');
  });

  // Avatar Photo Upload Handler
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.profile-avatar-file-input');
    if (!input || !input.files || !input.files[0]) return;

    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const base64 = event.target.result;
      localStorage.setItem('arks_profile_photo', base64);
      document.querySelectorAll('.profile-avatar-img-dynamic, #HeaderAvatarImg, #DropdownAvatarImg, #AvatarActionPreviewImg').forEach(img => {
        img.src = base64;
      });
      if (typeof window.closeAvatarActionModal === 'function') {
        window.closeAvatarActionModal();
      }
      showArksToast('Profile photo updated successfully!');
    };
    reader.readAsDataURL(file);
  });

  // Add Address Form & Card Action Handlers
  document.addEventListener('click', (e) => {
    if (e.target.closest('.btn-toggle-add-address')) {
      const container = e.target.closest('.profile-tab-pane') || document;
      const box = container.querySelector('.profile-add-address-box');
      if (box) box.style.display = 'block';
    }
    if (e.target.closest('.btn-cancel-add-address')) {
      const container = e.target.closest('.profile-tab-pane') || document;
      const box = container.querySelector('.profile-add-address-box');
      if (box) box.style.display = 'none';
    }

    // Set Default Address Button
    const setDefBtn = e.target.closest('.btn-set-default-address');
    if (setDefBtn) {
      const card = setDefBtn.closest('.profile-address-card');
      const grid = setDefBtn.closest('.profile-addresses-grid');
      if (card && grid) {
        grid.querySelectorAll('.profile-address-card').forEach(c => {
          c.style.border = '1px solid #eaeaec';
          c.style.background = '#FFFFFF';
          const badge = c.querySelector('.address-default-badge');
          if (badge) badge.style.display = 'none';
          const btn = c.querySelector('.btn-set-default-address');
          if (btn) btn.textContent = 'Set as Default';
        });
        card.style.border = '1.5px solid var(--color-primary)';
        card.style.background = '#fdfafb';
        const badge = card.querySelector('.address-default-badge');
        if (badge) badge.style.display = 'inline-block';
        setDefBtn.textContent = '✓ Default';
        showArksToast('Default delivery address updated!');
      }
    }

    // Delete Address Button
    const delAddrBtn = e.target.closest('.btn-delete-address');
    if (delAddrBtn) {
      const card = delAddrBtn.closest('.profile-address-card');
      if (card) {
        card.remove();
        showArksToast('Address removed');
      }
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.profile-add-address-form');
    if (!form) return;
    e.preventDefault();

    const name = form.querySelector('.new-addr-name').value;
    const phone = form.querySelector('.new-addr-phone').value;
    const street = form.querySelector('.new-addr-street').value;
    const city = form.querySelector('.new-addr-city').value;
    const state = form.querySelector('.new-addr-state').value;
    const zip = form.querySelector('.new-addr-zip').value;

    const newCard = document.createElement('div');
    newCard.className = 'profile-address-card';
    newCard.style.cssText = 'border: 1px solid #eaeaec; background: #FFFFFF; border-radius: 12px; padding: 20px; position: relative;';
    newCard.innerHTML = `
      <span class="address-default-badge" style="display: none; position: absolute; top: 16px; right: 16px; background: #e6f4f2; color: var(--color-primary); font-size: 11px; font-weight: 700; padding: 3px 8px; border-radius: 4px;">DEFAULT</span>
      <strong style="font-size: 15px; color: #282c3f; display: block; margin-bottom: 8px;">${name}</strong>
      <p style="font-size: 13.5px; color: #696b79; line-height: 1.6; margin: 0 0 12px;">
        ${street}<br>
        ${city}, ${state} - ${zip}<br>
        India<br>
        <strong>Mobile:</strong> ${phone}
      </p>
      <div style="display: flex; gap: 8px; margin-top: 8px; padding-top: 10px; border-top: 1px solid #f0f0f2;">
        <button type="button" class="btn btn-outline btn-sm btn-set-default-address" style="font-size: 11.5px; padding: 5px 12px; border-radius: 6px;">Set as Default</button>
        <button type="button" class="btn btn-outline btn-sm btn-delete-address" style="font-size: 11.5px; padding: 5px 12px; border-radius: 6px; color: #DC2626; border-color: #FECDD3;">Remove</button>
      </div>
    `;

    document.querySelectorAll('.profile-addresses-grid').forEach(grid => {
      grid.appendChild(newCard.cloneNode(true));
    });

    document.querySelectorAll('.profile-add-address-box').forEach(box => box.style.display = 'none');
    form.reset();
    showArksToast('New address saved successfully!');
  });

  // If URL has hash on page load or changes (e.g. #orders, #wallet, #coupons, #addresses, #wishlist, #bag)
  function handleUrlHashTab() {
    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      const validTabs = ['profile-details', 'orders', 'wishlist', 'bag', 'addresses', 'wallet', 'coupons', 'support'];
      if (validTabs.includes(hash)) {
        window.ARKS_ProfileModal.switchTab(hash, true);
      }
    }
  }
  handleUrlHashTab();
  window.addEventListener('hashchange', handleUrlHashTab);

  // Mobile Search Bar Toggle
  const mobileSearchToggle = document.querySelector('#MobileSearchToggle');
  const mobileSearchBar = document.querySelector('#MobileSearchBar');

  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', () => {
      const isVisible = mobileSearchBar.style.display !== 'none';
      mobileSearchBar.style.display = isVisible ? 'none' : 'block';
      if (!isVisible) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const input = mobileSearchBar.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 150);
      }
    });
  }
});
